<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <div v-show="!isAefProfileVisible && !isCefProfileVisible">
              <el-row>
                <el-col>
                  <span class="cs-title">账单信息</span>
                </el-col>
              </el-row>
              <autonomousWorkflowList ref="autonomousWorkflowList" @view="onView" />
            </div>
            <aefAccountProfile v-show="isAefProfileVisible" :data="dataForAefAccountProfile" @close="closeAefAccountProfile" />
            <cefAccountProfile v-show="isCefProfileVisible" :data="dataForCefAccountProfile" @close="closeCefAccountProfile" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import navigator from "../../components/navigator";
import autonomousWorkflowList from "../../components/addCollectFees/autonomousWorkflowList";
import cefAccountProfile from "@/components/finance/cefAccountProfile";
import aefAccountProfile from "@/components/finance/aefAccountProfile";

export default {
  data() {
    return {
      isAefProfileVisible: false,
      dataForAefAccountProfile: {},
      isCefProfileVisible: false,
      dataForCefAccountProfile: {},
    };
  },
  components: {
    navigator,
    autonomousWorkflowList,
    aefAccountProfile,
    cefAccountProfile,
  },
  computed: {},
  created() {
    if (this.$route.query.enrollmentType && this.$route.query.accountId){
      this.$nextTick(() =>{
         this.onView(this.$route.query.enrollmentType, this.$route.query.accountId);
      });
    }
  },
  mounted() {},
  methods: {
    onView(enrollmentType, accountId) {
      
      if (enrollmentType == 1) {//占位
        this.dataForAefAccountProfile = {
          accountId: accountId,
          isAutonomous: true,
        };
        this.isAefProfileVisible = true;
      } else if (enrollmentType == 2) { //课程报名
        this.dataForCefAccountProfile = {
          accountId: accountId,
          isAutonomous: true,
        };
        this.isCefProfileVisible = true;
      }
    },
    closeAefAccountProfile(isReload) {
      this.isAefProfileVisible = false;
      if (isReload){
        this.$refs.autonomousWorkflowList.search();
      }
    },
    closeCefAccountProfile(isReload) {
      this.isCefProfileVisible = false;
      if (isReload){
        this.$refs.autonomousWorkflowList.search();
      }
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/page/addCollectFees/autonomousList.vue